'use client';

import Image from 'next/image';
import { useRef } from 'react';
import FileDetail from '@/components/ui/FileDetail';
import { toast } from 'react-toastify';

export interface FileInfo {
  name: string;
  size: number;
  isLoading: boolean;
  file: File;
}

interface FileUploaderProps {
  fileInfo: FileInfo[];
  onAddFile: (file: File) => void;
  onRemove: (index: number) => void;
  maxFiles?: number;
}

export default function FileUploader({
  fileInfo,
  onAddFile,
  onRemove,
  maxFiles = 3,
}: FileUploaderProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (!files || files.length === 0) return;

    const file = files[0];
    if (file.size > 20 * 1024 * 1024) {
      toast.error('Файлын хэмжээ 20MB-с ихгүй байх ёстой');
      event.target.value = '';
      return;
    }

    onAddFile(file);
    event.target.value = '';
  };

  return (
    <div className="flex w-full">
      {fileInfo.length < maxFiles && (
        <div className="flex grow-2 min-w- border border-dashed rounded-xl border-[#4E74FF] py-6 items-center justify-center">
          <div
            className="text-center cursor-pointer"
            onClick={handleButtonClick}
          >
            <Image
              width={24}
              height={24}
              alt="upload icon"
              src="/icons/icon-upload.svg"
              className="mx-auto block"
            />
            <button type="button" className="text-primary font-normal text-sm">
              Сонгох
            </button>
            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              className="hidden"
              name="files"
              accept="image/*"
            />
          </div>
        </div>
      )}
      <div
        className={`${
          fileInfo.length > 0
            ? `block ml-4 ${fileInfo.length >= maxFiles ? 'w-full' : 'grow-9 '}`
            : 'hidden'
        }`}
      >
        <div className="max-h-30 overflow-y-auto w-full space-y-2 scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100">
          {fileInfo.map((detail, index) => (
            <FileDetail
              name={detail.name}
              key={`${detail.name}-${detail.size}-${index}`}
              size={detail.size}
              isLoading={detail.isLoading}
              onRemove={() => onRemove(index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
